import { Report_promotion_service } from "../services/Report_promotion_service";
import { Loading } from "element-ui"
import moment from "moment";
const state = {
  set_data: [],
  service_rate: ["หน่วย: บาท/Kbps", "หน่วย: บาท/Mbps"],
  title_text: "",
  text_service_rate: "",
  month_th: ["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน ","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"],
  short_month : ['ม.ค.','ก.พ.','มี.ค','เม.ย.','พ.ค.','มิ.ย.','ก.ค.','ส.ค.','ก.ย.','ต.ค.','พ.ย.','ธ.ค.'],
  prototype : {
    chart:{
      type : 'spline'
    },
    title: {
        text: ''
    },
    yAxis: {
        title: {
            text: ''
        }
    },
    xAxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    },
    series: [],
    responsive: {
        rules: [{
            condition: {
                maxWidth: 500
            },
            chartOptions: {
                legend: {
                    layout: 'horizontal',
                    align: 'center',
                    verticalAlign: 'bottom'
                }
            }
        }]
    },
    plotOptions: {
      spline: {
          dataLabels: {
              enabled: true
          },
          enableMouseTracking: false
      }
    },
    credits: {
      enabled: false
    },
    exporting: {
      buttons: {
        contextButton: {
          menuItems: [
            'printChart',
            'downloadXLS'
          ]
        }
      }
    }
  },
  chart : {
    chart:{
      type : 'spline'
    },
    title: {
        text: ''
    },
    yAxis: {
        title: {
            text: ''
        }
    },
    xAxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    },
    series: [],
    responsive: {
        rules: [{
            condition: {
                maxWidth: 500
            },
            chartOptions: {
                legend: {
                    layout: 'horizontal',
                    align: 'center',
                    verticalAlign: 'bottom'
                }
            }
        }]
    },
    plotOptions: {
      spline: {
          dataLabels: {
              enabled: true
          },
          enableMouseTracking: false
      }
    },
    credits: {
      enabled: false
    },
    exporting: {
      chartOptions: {
        plotOptions: {
            spline: {
                dataLabels: {
                    enabled: false,
                    style: {
                        fontSize: '9px'
                    }
                }
            }
        },
        title: {
            style: {
                fontSize: '13px'
            }
        },
        legend: {
            itemStyle: {
                fontSize: '9px'
            }
        },
        scale: 2,
        chart: {
          height: 400,
          width: 920
        },
        sourceHeight: 400,
        sourceWidth: 920
    },
      buttons: {
        contextButton: {
          menuItems: [
            'printChart',
            'downloadXLS'
          ]
        }
      }
    }
  },
  chart_result : true,
  display_chart : false
};
const actions = {
  async report_between_month({ commit,state }, data) {
    let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
    data.daterange = {
      start : moment(data.type_data.monthfrom).format('YYYY-MM-DD'),
      end : moment(data.type_data.monthto).add(1, 'M').subtract(1, 'd').format('YYYY-MM-DD')
    }
    data.classify = true
    data.date_range = !data.forecast ? data.daterange : false
    let result = await Report_promotion_service.getBroadbandAvgByTechnology(data)
    let forecast = await Report_promotion_service.getBroadbandForecast(data)
    if(!result.data.length) {
      setTimeout(function(){ loadingInstance.close() }, 250);
      return commit('CHART_RESULT',false)
    }
    let technology_title = data.promotion_technology ? "โดยการเชื่อมต่อแบบ " +  data.promotion_technology+" " : ""
    let top_title = "อัตราค่าบริการเฉลี่ยของบริการอินเทอร์เน็ตความเร็วสูงประจำที่"+technology_title+
      "เดือน" +state.month_th[parseInt(moment(data.type_data.monthfrom).format("M"))-1] +
      " ปี พ.ศ. " +moment(data.type_data.monthfrom).add(543,'Y').format("YYYY") +
      " ถึงเดือน" +state.month_th[parseInt(moment(data.type_data.monthto).format("M")) - 1] +
      " ปี พ.ศ. " +moment(data.type_data.monthto).add(543,'Y').format("YYYY");
    let left_title = "บาท / "+data.service_rate
    let service_rate = data.service_rate == 'Kbps' ? 0.001 : 1
    let steps = data.service_rate == 'Kbps' ? 3 : 2
    let milestone = []
    let wgt = {}
    for(let date = data.type_data.monthfrom ; date <= data.type_data.monthto ; date = moment(date).add(1,'M')){
      milestone.push(state.short_month[moment(date).format('M')-1]+'-'+moment(date).add(543,'Y').format('YY'))
      wgt[moment(date).format('MM-YYYY')] = {val : 0 , total : 0}
    }
    let series = []
    let counting = {
      total : {},
      value : {},
      devider : {}
    }
    for(let item of result.data){
      counting.total[moment(item.monthly_regulate).format('MM-YYYY')] 
      ? counting.total[moment(item.monthly_regulate).format('MM-YYYY')].push(item) 
      : counting.total[moment(item.monthly_regulate).format('MM-YYYY')] = [item]
    }
    for(let provider of data.service_providers){
      let name = data.compare_type == 'group' ? provider.group_name_th : provider.brand_name
      let color = data.compare_type == 'group' ? provider.group_color_code : provider.provider_color
      let item_group = data.compare_type == 'group' ? JSON.parse(provider.group_company_list) : [provider.id]
      let provider_data = result.data.filter(item => item_group.includes(item.provider_id))
      let chartdata = []
      let promotion_amount = []
      for(let date = data.type_data.monthfrom ; date <= data.type_data.monthto ; date = moment(date).add(1,'M')){
        let monthdata = provider_data.filter(item => moment(item.monthly_regulate).format('MM-YYYY') == moment(date).format('MM-YYYY'))
        if(monthdata.length){
          let temp = 0
          let amount = 0
          for(let i = 0 ; i < monthdata.length ; i++){
            temp += monthdata[i].internet_per_Mbps
            amount += monthdata[i].total
          }
          let avg = data.service_rate == 'Kbps' ?  (temp/monthdata.length)*service_rate : (temp/monthdata.length)*service_rate
          chartdata.push(avg)
          promotion_amount.push(amount)
          if(data.weighting){
            for(let item of monthdata){
              let key = moment(item.monthly_regulate).format('MM-YYYY')
              wgt[key].val += item.internet_per_Mbps*item.total
              wgt[key].total += item.total
            }
            counting.value[moment(date).format('MM-YYYY')] = counting.value[moment(date).format('MM-YYYY')] 
            ? counting.value[moment(date).format('MM-YYYY')] += parseFloat(temp/monthdata.length*service_rate)
            : parseFloat(temp/monthdata.length*service_rate)
          }
        }else{
          chartdata.push(null)
          promotion_amount.push(null)
        } 
      }
      if(data.forecast){
        if(milestone.indexOf('Forecast') == -1) {
          milestone.push('Forecast')
        }
        let temp_forecast = forecast.data.filter(data => data.name == name)
        chartdata.push(temp_forecast[0].data[0])
        promotion_amount.push(temp_forecast[0].amount)
      }
      series.push({
        name : name,
        data : chartdata,
        amount : promotion_amount,
        color : color
      })
    }
    if(data.average) {
      if (data.weighting) {
        let avg_data = []
        for (let i = 0; i < series[0].data.length; i++) {
          let avg = series.reduce((total, data) => total + (data.data[i] * data.amount[i]), 0)/series.reduce((total, data) => total + data.amount[i], 0)
          avg = avg > 0 && !isNaN(avg) ?  avg : null
          if (i != (series[0].data.length -1)) {
            avg_data.push(avg)
          } else {
            avg_data.push(forecast.data[forecast.data.length - 1].data)
          }
        }
        series.push({
          name: 'ค่าเฉลี่ยถ่วงน้ำหนัก',
          data: avg_data,
          color: '#000000'
        })
      } else {
        let avg_data = []
        for(let i = 0 ; i < series[0].data.length; i++){
          var avg = []
          for(let provider of series){
            avg.push(provider.data[i])
          }
          avg = avg.filter(n => n > 0)
          avg = avg.length ? eval(avg.join('+'))/avg.length : null
          avg_data.push(avg)
        }
        series.push({
          name: 'ค่าเฉลี่ย',
          data: avg_data,
          color: '#000000'
        })
      }
    }
    let obj = {
      series : series,
      top_title : top_title,
      left_title : left_title,
      milestone : milestone,
      decimal : steps
    }
    commit('SET_DATA_CHART',obj)
    setTimeout(function(){ loadingInstance.close() }, 250);
  },
  async report_year({ commit,state }, data) {
    let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
    let start = moment(data.type_data.year).format('YYYY-MM-DD')
    let end = moment(data.type_data.year).add(1,'Y')
        end = moment(end).subtract(1,'d')._d
        end = moment(end).format('YYYY-MM-DD')
    data.daterange = {
      start : start,
      end : end
    }
    data.classify = true
    data.date_range = !data.forecast ? data.daterange : false
    let result = await Report_promotion_service.getBroadbandAvgByTechnology(data)
    let forecast = await Report_promotion_service.getBroadbandForecast(data)
    if(result.status === 200){
      if(!result.data.length) {
        setTimeout(function(){ loadingInstance.close() }, 250);
        return commit('CHART_RESULT',false)
      }
      let tech_title = data.promotion_technology ? "โดยการเชื่อมต่อแบบ "+data.promotion_technology+" " : ""
      let top_title = "อัตราค่าบริการเฉลี่ยของบริการอินเทอร์เน็ตความเร็วสูงประจำที่" +tech_title+"ปี พ.ศ. "+moment(data.type_data.year).add(543,'Y').format('YYYY')
      let left_title = "บาท / "+data.service_rate
      let milestone = state.short_month
      let service_rate = data.service_rate == 'Kbps' ? 0.001 : 1
      let decimal = data.service_rate == 'Kbps' ? 3 : 2
      let series = []
      let counting = {
        total : {},
        value : {}
      }
      let wgt = {}
      let devider = {}
      for(let item of result.data){
        let key = moment(item.monthly_regulate).format('MM-YYYY')
        wgt[key]  ? wgt[key] += parseFloat((item.internet_per_Mbps*item.total*service_rate).toFixed(decimal)) || null
                  : wgt[key] = parseFloat((item.internet_per_Mbps*item.total*service_rate).toFixed(decimal)) || null
        devider[key] ? devider[key] += item.total : devider[key] = item.total
      }
      for(let provider of data.service_providers){
        let name = data.compare_type == 'group' ? provider.group_name_th : provider.brand_name
        let color = data.compare_type == 'group' ? provider.group_color_code : provider.provider_color
        let item_group = data.compare_type == 'group' ? JSON.parse(provider.group_company_list) : [provider.id]
        let provider_data = result.data.filter(item => item_group.includes(item.provider_id))
        let chartdata = []
        let promotion_amount = []
        for(let date = moment(start) ; date <= moment(end) ; date = moment(date).add(1,'M')){
          let datedata = provider_data.filter(item => moment(item.monthly_regulate).format('MM-YYYY') == moment(date).format('MM-YYYY'))
          if(datedata.length){
            let temp = 0
            let amount = 0
            for(let i = 0 ; i < datedata.length ; i++){
              temp += datedata[i].internet_per_Mbps
              amount += datedata[i].total
            }
            let avg = (temp/datedata.length)*service_rate
            chartdata.push(avg)
            promotion_amount.push(amount)
          }else{
            chartdata.push(null)
            promotion_amount.push(null)
          }
        }
        if(data.forecast){
          if(milestone.indexOf('Forecast') == -1) {
            milestone.push('Forecast')
          }
          let temp_forecast = forecast.data.filter(data => data.name == name)
          chartdata.push(temp_forecast[0].data[0])
          promotion_amount.push(temp_forecast[0].amount)
        }
        series.push({
          name : name,
          data : chartdata,
          amount : promotion_amount,
          color : color
        })
      }
      if(data.average) {
        if (data.weighting) {
          let avg_data = []
          for (let i = 0; i < series[0].data.length; i++) {
            let avg = series.reduce((total, data) => total + (data.data[i] * data.amount[i]), 0)/series.reduce((total, data) => total + data.amount[i], 0)
            avg = avg > 0 && !isNaN(avg) ?  avg : null
            if (i != series[0].data.length -1) {
              avg_data.push(avg)
            } else {
              avg_data.push(forecast.data[forecast.data.length - 1].data)
            }
          }
         
          series.push({
            name: 'ค่าเฉลี่ยถ่วงน้ำหนัก',
            data: avg_data,
            color: '#000000'
          })
        } else {
          let avg_data = []
          for (let i = 0; i < series[0].data.length; i++) {
            let avg = series.reduce((total, data) => total + data.data[i], 0)/series.filter(provider => provider.data[0] != null).length
            avg = avg > 0 && !isNaN(avg) ?  avg : null
            avg_data.push(avg)
          }
          series.push({
            name: 'ค่าเฉลี่ย',
            data: avg_data,
            color: '#000000'
          })
        }
      }
      let obj = {
        series : series,
        top_title : top_title,
        left_title : left_title,
        milestone : milestone,
        decimal : decimal
      }
      commit('SET_DATA_CHART', obj)
      setTimeout(function(){ loadingInstance.close() }, 250);
    }
  },
  async report_between_year({ commit }, data) {
    let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
    let start = moment(data.type_data.yearfrom).format('YYYY-MM-DD')
    let end = moment(data.type_data.yearto).add(1,'Y')
        end = moment(end).subtract(1,'d').format('YYYY-MM-DD')
    data.daterange = {
      start : start,
      end : end
    }
    data.classify = true
    data.date_range = !data.forecast ? data.daterange : false
    let result = await Report_promotion_service.getBroadbandAvgByTechnology(data)
    let forecast = await Report_promotion_service.getBroadbandForecast(data)
    if(result.status === 200){
      if(!result.data.length) {
        setTimeout(function(){ loadingInstance.close() }, 250);
        return commit('CHART_RESULT',false)
      }
      let tech_title = data.type_data.promotion_technology ? "โดยการเชื่อมต่อแบบ "+data.type_data.promotion_technology+" " : ""
      let top_title = "อัตราค่าบริการเฉลี่ยของบริการอินเทอร์เน็ตความเร็วสูงประจำที่" +tech_title
                    +"ปี พ.ศ. "+moment(start).add(543,'Y').format('YYYY')+' ถึงปี พ.ศ. '+moment(end).add(543,'Y').format('YYYY')
      let left_title = "บาท / "+data.service_rate
      let service_rate = data.service_rate == 'Kbps' ? 0.001 : 1 
      let steps = data.service_rate == 'Kbps' ? 3 : 2
      let milestone = []
      let weight = {}
      let devider = {}
      for(let y = moment(start) ; y < moment(end) ; y = moment(y).add(1,'Y')){
        milestone.push(moment(y).add(543,'Y').format('YYYY'))
      }
      let avg_data = []
      let temp_index = []
      for(let y = moment(start) ; y < moment(end) ; y = moment(y).add(1,'M')){
        weight[moment(y).format('YYYY-MM-DD')] = 0
        devider[moment(y).format('YYYY-MM-DD')] = 0
        if (temp_index.indexOf(moment(y).format('YYYY-MM-DD')) == -1) {
          temp_index.push(moment(y).format('YYYY-MM-DD'))
        } else {
          continue;
        }
        avg_data.push({month: moment(y).format('YYYY-MM-DD'), data: [], total: 0, weight: 0})
      }
      let series = []
      let counting = {
        total : {},
        value : {}
      }
      for (let item of result.data) {
        let key = moment(item.monthly_regulate).format('YYYY-MM-DD')
        weight[key] += item.internet_per_Mbps*item.total
        devider[key] += item.total
        counting.total[key] ? counting.total[key].push(item) : counting.total[key] = [item]
        avg_data[temp_index.indexOf(key)].weight += item.internet_per_Mbps*item.total
        avg_data[temp_index.indexOf(key)].total += item.total
        avg_data[temp_index.indexOf(key)].data.push(item.internet_per_Mbps)
      }
      for(let provider of data.service_providers){
        let name = data.compare_type == 'group' ? provider.group_name_th : provider.brand_name
        let color = data.compare_type == 'group' ? provider.group_color_code : provider.provider_color
        let item_group = data.compare_type == 'group' ? JSON.parse(provider.group_company_list) : [provider.id]
        let provider_data = result.data.filter(item => item_group.includes(item.provider_id))
        let chartdata = []
        let promotion_amount = []
        for(let date = moment(start) ; date <= moment(end) ; date = moment(date).add(1,'Y')){
          let yeardata = provider_data.filter(item => moment(item.monthly_regulate).format('YYYY') == moment(date).format('YYYY'))
          if(yeardata.length){
            let avg = 0
            let amount = 0
            for(let item of yeardata){
              avg += item.internet_per_Mbps
              amount += item.total
            }
            avg = (avg/yeardata.length)*service_rate
            chartdata.push(avg)
            promotion_amount.push(amount)
          }else{
            chartdata.push(null)
            promotion_amount.push(null)
          }
        }
        if(data.forecast){
          if(milestone.indexOf('Forecast') == -1) {
            milestone.push('Forecast')
          }
          let temp_forecast = forecast.data.filter(data => data.name == name)
          chartdata.push(temp_forecast[0].data[0])
        }
        series.push({
          name : name,
          data : chartdata,
          amount : promotion_amount,
          color : color
        })
      }
      if(data.average) {
        if (data.weighting) {
          let temp_data = []
          for(let y = moment(start) ; y < moment(end) ; y = moment(y).add(1,'Y')){
            let year = avg_data.filter(data => data ? moment(data.month).year() == moment(y).year() : null)
            let weight_avg = year.reduce((total, year) => total += year.total > 0 ? (year.weight/year.total) : year.weight, 0) / year.filter(year => year.total > 0).length
            temp_data.push(weight_avg > 0 ? weight_avg : null)
          }
          if(data.forecast) {
            temp_data.push(forecast.data[forecast.data.length - 1].data)
          }
          series.push({
            name: 'ค่าเฉลี่ยถ่วงน้ำหนัก',
            data: temp_data,
            color: '#000000'
          })
        } else {
          let temp_data = []
          for(let y = moment(start) ; y < moment(end) ; y = moment(y).add(1,'Y')){
            let year = avg_data.filter(data => data ? moment(data.month).year() == moment(y).year() : null)
            let avg = year.reduce((total, year) => total += year.data.reduce((temp_total, temp_month) => temp_total += temp_month, 0)/(year.data.length > 0 ? year.data.length : 1), 0) / year.filter(year => year.data.length > 0).length
            temp_data.push(avg > 0 ? avg : null)
          }
          if(data.forecast) {
            temp_data.push(forecast.data[forecast.data.length - 1].data)
          }
          series.push({
            name: 'ค่าเฉลี่ย',
            data: temp_data,
            color: '#000000'
          })
        }
      }
      let obj = {
        series : series,
        top_title : top_title,
        left_title : left_title,
        milestone : milestone,
        decimal : steps
      }
      commit('SET_DATA_CHART', obj)
      setTimeout(function(){ loadingInstance.close() }, 250);
    }
  },
  async report_quarter({ commit,state }, data){
    let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
    let start = moment(data.type_data.quarter_year).add((data.type_data.quarter-1)*3,'M').format('YYYY-MM-DD')
    let end = moment(start).add(3,'M')
        end = moment(end).subtract(1,'d').format('YYYY-MM-DD')
    data.daterange = {
      start : start,
      end : end
    }
    data.classify = true
    data.date_range = !data.forecast ? data.daterange : false
    let result = await Report_promotion_service.getBroadbandAvgByTechnology(data)
    let forecast = await Report_promotion_service.getBroadbandForecast(data)
    if(result.status === 200){
      if(!result.data.length) {
        setTimeout(function(){ loadingInstance.close() }, 250);
        return commit('CHART_RESULT',false)
      }
      let technology_title = data.promotion_technology ?  "โดยการเชื่อมต่อแบบ "+data.promotion_technology+" " : ""
      let top_title = "อัตราค่าบริการเฉลี่ยของบริการอินเทอร์เน็ตความเร็วสูงประจำที่" +technology_title+"ในไตรมาสที่ "+data.type_data.quarter+" ปี พ.ศ. "+moment(data.type_data.quarter_year).add(543,'Y').format('YYYY')
      let left_title = "บาท / "+data.service_rate
      let service_rate = data.service_rate == 'Kbps' ? 0.001 : 1 
      let steps = data.service_rate == 'Kbps' ? 3 : 2
      let milestone = []
      let wgt = {}
      let devider = {}
      for(let q = moment(start) ; q < moment(end) ; q = moment(q).add(1,'M')){
        milestone.push(state.short_month[moment(q).format('M')-1]+'-'+moment(data.type_data.quarter_year).add(543,'Y').format('YY'))
        wgt[moment(q).format('MM-YYYY')] = 0
        devider[moment(q).format('MM-YYYY')] = 0
      }
      if(data.forecast){
        milestone.push('Forecast')
      }
      let series = []
      let counting = {
        total : {},
        value : {}
      }
      for(let item of result.data){
        counting.total[moment(item.monthly_regulate).format('MM-YYYY')] 
          ? counting.total[moment(item.monthly_regulate).format('MM-YYYY')].push(item) 
          : counting.total[moment(item.monthly_regulate).format('MM-YYYY')] = [item]
        wgt[moment(item.monthly_regulate).format('MM-YYYY')] += item.internet_per_Mbps*item.total
        devider[moment(item.monthly_regulate).format('MM-YYYY')] += item.total
      }
      for(let provider of data.service_providers){
        let name = data.compare_type == 'group' ? provider.group_name_th : provider.brand_name
        let color = data.compare_type == 'group' ? provider.group_color_code : provider.provider_color
        let item_group = data.compare_type == 'group' ? JSON.parse(provider.group_company_list) : [provider.id]
        let providerdata = result.data.filter(item => item_group.includes(item.provider_id))
        let chartdata = []
        let promotion_amount = []
        for(let q = moment(start) ; q < moment(end) ; q = moment(q).add(1,'M')){
          let monthdata = providerdata.filter(item => moment(item.monthly_regulate).format('MM-YYYY') == moment(q).format('MM-YYYY'))
          if(monthdata.length){
            let temp = 0
            let amount = 0
            for(let item of monthdata){
              temp += item.internet_per_Mbps
              amount += item.total
            }
            temp = (temp/monthdata.length)*service_rate
            chartdata.push(temp)
            promotion_amount.push(amount)
          }else{
            chartdata.push(null)
            promotion_amount.push(null)
          }
        }
        if(data.forecast){
          if(milestone.indexOf('Forecast') == -1) {
            milestone.push('Forecast')
          }
          let temp_forecast = forecast.data.filter(data => data.name == name)
          chartdata.push(temp_forecast[0].data[0])
        }
        series.push({
          name : name,
          data : chartdata,
          amount : promotion_amount,
          color : color
        })
      }
      if(data.average) {
        if (data.weighting) {
          let avg_data = []
          for (let i = 0; i < series[0].data.length; i++) {
            let avg = series.reduce((total, data) => total + (data.data[i] * data.amount[i]), 0)/series.reduce((total, data) => total + data.amount[i], 0)
            avg = avg > 0 && !isNaN(avg) ? avg : null
            if (i != series[0].data.length -1) {
              avg_data.push(avg)
            } else {
              if (data.forecast) {
                avg_data.push(forecast.data[forecast.data.length - 1].data)
              } else {
                avg_data.push(avg)
              }
              
            }
          }
          series.push({
            name: 'ค่าเฉลี่ยถ่วงน้ำหนัก',
            data: avg_data,
            color: '#000000'
          })
        } else {
          let avg_data = []
          for (let i = 0; i < series[0].data.length; i++) {
            let avg = series.reduce((total, data) => total + data.data[i], 0)/series.filter(provider => provider.data[i] != null).length
            avg = avg > 0 && !isNaN(avg) ? avg : null
            avg_data.push(avg)
          }
          series.push({
            name: 'ค่าเฉลี่ย',
            data: avg_data,
            color: '#000000'
          })
        }
      }
      let obj = {
        series : series,
        top_title : top_title,
        left_title : left_title,
        milestone : milestone,
        decimal : steps
      }
      commit('SET_DATA_CHART', obj)
      setTimeout(function(){ loadingInstance.close() }, 250);
    }
  },
  async report_between_quarter({ commit }, data){
    let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
    let start = data.daterange.start
    let end = data.daterange.end
        data.date_range = !data.forecast ? data.daterange : false
        data.classify = true
    let result = await Report_promotion_service.getBroadbandAvgByTechnology(data)
    let forecast = await Report_promotion_service.getBroadbandForecast(data)
    if(result.status === 200){
      if(!result.data.length) {
        loadingInstance.close()
        return commit('CHART_RESULT',false)
      }
      let technology_title = data.promotion_technology ? "โดยการเชื่อมต่อแบบ "+data.promotion_technology+" " : ""
      let top_title = "อัตราค่าบริการเฉลี่ยของบริการอินเทอร์เน็ตความเร็วสูงประจำที่"+technology_title+"ในไตรมาสที่ "+data.type_data.quarterfrom+" ปี พ.ศ."+moment(data.type_data.quarter_year_from).add(543,'Y').year()+ 
                      " ถึงไตรมาสที่ "+data.type_data.quarterto+" ปี พ.ศ."+moment(data.type_data.quarter_year).add(543,'Y').year()
      let left_title = "บาท / "+data.service_rate
      let service_rate = data.service_rate == 'Kbps' ? 0.001 : 1
      let steps  = data.service_rate == 'Kbps' ? 3 : 2
      let milestone = []
      let wgt = {}, devider = {}
      for(let q = moment(start) ; q < moment(end) ; q = moment(q).add(1,'Q')){
        milestone.push(moment(q).quarter()+'Q'+moment(q).add(543,'Y').format('YYYY'))
        let key  = moment(q).quarter()+'Q'+moment(q).format('YYYY')
        wgt[key] = 0
        devider[key] = 0
      }
      let series = []
      let counting = {
        total : {},
        value : {}
      }
      for(let item of result.data){
        let key  = moment(item.monthly_regulate).quarter()+'Q'+moment(item.monthly_regulate).format('YYYY')
        counting.total[key] ? counting.total[key].push(item) : counting.total[key] = [item]
        wgt[key] += item.internet_per_Mbps * item.total
        devider[key] += item.total
      }
      for(let provider of data.service_providers){
        let name = data.compare_type == 'group' ? provider.group_name_th : provider.brand_name
        let color = data.compare_type == 'group' ? provider.group_color_code : provider.provider_color
        let item_group = data.compare_type == 'group' ? JSON.parse(provider.group_company_list) : [provider.id]
        let provider_data = result.data.filter(item => item_group.includes(item.provider_id))
        let chartdata = []
        let promotion_amount = []
        for(let date = moment(start) ; date <= moment(end) ; date = moment(date).add(3,'M')){
          let quarter_start = moment(date).subtract(1,'seconds')
          let quarter_end  = moment(date).add(3,'M')
              quarter_end = moment(quarter_end).subtract(1,'seconds')
          let quarter_data = provider_data.filter(item => moment(item.monthly_regulate).isBetween(quarter_start,quarter_end) )
          if(quarter_data.length){
            let temp = 0
            let amount = 0
            for(let i = 0 ; i < quarter_data.length ; i++){
              temp += quarter_data[i].internet_per_Mbps
              amount += quarter_data[i].total
            }
            let avg = (temp/quarter_data.length)*service_rate
            chartdata.push(avg)
            promotion_amount.push(amount)
          }else{
            chartdata.push(null)
            promotion_amount.push(null)
          }
        }
        if(data.forecast){
          if(milestone.indexOf('Forecast') == -1) {
            milestone.push('Forecast')
          }
          let temp_forecast = forecast.data.filter(data => data.name == name)
          chartdata.push(temp_forecast[0].data[0])
        }
        series.push({
          name : name,
          data : chartdata,
          amount : promotion_amount,
          color : color
        })
      }
      if(data.average) {
        if (data.weighting) {
          let avg_data = []
          for (let i = 0; i < series[0].data.length; i++) {
            let avg = series.reduce((total, data) => total + (data.data[i] * data.amount[i]), 0)/series.reduce((total, data) => total + data.amount[i], 0)
            avg = avg > 0 && !isNaN(avg) ? avg : null
            if (i != series[0].data.length -1) {
              avg_data.push(avg)
            } else {
              if (data.forecast) {
                avg_data.push(forecast.data[forecast.data.length - 1].data)
              } else {
                avg_data.push(avg)
              }
            }
          }
          series.push({
            name: 'ค่าเฉลี่ยถ่วงน้ำหนัก',
            data: avg_data,
            color: '#000000'
          })
        } else {
          let avg_data = []
          for (let i = 0; i < series[0].data.length; i++) {
            let avg = series.reduce((total, data) => total + data.data[i], 0)/series.filter(provider => provider.data[i] != null).length
            avg = avg > 0 && !isNaN(avg) ? avg : null
            avg_data.push(avg)
          }
          series.push({
            name: 'ค่าเฉลี่ย',
            data: avg_data,
            color: '#000000'
          })
        }
      }
      let obj = {
        series : series,
        top_title : top_title,
        left_title : left_title,
        milestone : milestone,
        decimal : steps
      }
      commit('SET_DATA_CHART', obj)
      setTimeout(function(){ loadingInstance.close() }, 250);
    }
  }
}

const mutations = {
  SET_DATA_CHART(state, data){
    state.chart.title.text = data.top_title
    state.chart.yAxis.title.text = data.left_title
    state.chart.xAxis.categories = data.milestone
    state.chart.series = data.series
    state.chart.tooltip = {
      headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
      '<td style="padding:0"><b>{point.y:.' + data.decimal + 'f}</b></td></tr>',
      footerFormat: '</table>',
      shared: true,
      useHTML: true
    }
    state.chart.plotOptions = {
      spline: {
        dataLabels: {
            enabled: false,
            format: `{point.y:.${data.decimal}f}`
        }
      }
    }
    state.chart.decimal = data.decimal
    state.chart.exporting = {
      showTable: false,
      chartOptions: {
        plotOptions: {
            spline: {
                dataLabels: {
                    enabled: false,
                    style: {
                        fontSize: '9px'
                    }
                }
            }
        },
        title: {
            style: {
                fontSize: '13px'
            }
        },
        legend: {
            itemStyle: {
                fontSize: '9px'
            }
        },
        scale: 2,
        chart: {
          height: 400,
          width: 920
        },
        sourceHeight: 400,
        sourceWidth: 920
    },
      csv: {
          columnHeaderFormatter: function(item, point) {
              if (!item || item.coll == "xAxis") {
                  return 'ช่วงเวลา'
              } else {
                  return {
                    topLevelColumnTitle: data.decimal == 2 ? 'บาท/Mbps' : 'บาท/Kbps',
                    columnTitle: point === 'y' ? item.name : point
                  };
              }
              
          }
      },
      buttons: {
        contextButton: {
          menuItems: [
            'printChart',
            'downloadXLS'
          ]
        }
      }
    }
    state.display_chart = true
    state.chart_result = true
  },
  SET_PROPORTION(state, data){
    state.main = data.main
    state.ontop = data.ontop
  },
  CHART_RESULT(state,status){
    state.chart_result  = status
    state.display_chart = status
  }
};

export const Report_G12 = {
  namespaced: true,
  state,
  actions,
  mutations
};
